import React from 'react';

function Cart({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 17"
      fill="none"
      {...otherProps}
    >
      <path
        d="M1 1.00003C1.90507 1.00003 3.5 1 4 1L5 2.99998M5 2.99998L7 9.99998H17L19 2.99998H5Z"
        stroke="#141B21"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8.5" cy="14.5" r="1.5" stroke="#141B21" strokeWidth="1.2" />
      <circle cx="15.5" cy="14.5" r="1.5" stroke="#141B21" strokeWidth="1.2" />
    </svg>
  );
}

export default Cart;
